import { useMutation } from "@tanstack/react-query";

import { ConsentDocumentsApi } from "@/data/api/consentDocumentsApi";

export const useSignConsentDocumentsMutation = () => {
  return useMutation({
    mutationFn: ({
      consentDocumentIds,
      signatureDataUri,
    }: {
      consentDocumentIds: string[];
      signatureDataUri: string;
    }) =>
      ConsentDocumentsApi.signConsentDocuments(
        consentDocumentIds,
        signatureDataUri,
      ),
  });
};
